import { render, staticRenderFns } from "./UserPaymentsList.vue?vue&type=template&id=392fe882"
import script from "./UserPaymentsList.vue?vue&type=script&lang=js"
export * from "./UserPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports